export default __webpack_public_path__ + "static/media/Tokens of Frozen Earth.a0bb52e7.jpg";